<template>
  
    <div class="col-md-12">
        <!--A METTRE DANS UN NOUVEAU COMPOSANT POUR APPEL-->
        <form @submit.prevent>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Nom de l'outil</label>
                        <input v-model="name" type="text" 
                            placeholder="Entrer le nom de l'outil" 
                                class="form-control"
                                @keypress="check_input($event)" 
                                minlength="2" 
                                maxlength="20"
                                required>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Code</label>
                        <input v-model="code" type="text" placeholder="Entrer le code de l'outil" class="form-control" readonly>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Marque</label>
                        <select class="form-control" v-model="manufacturer" required >
                            <option disabled v-bind:value="null" selected>Choisissez une marque de matériel</option>
                            <option v-for="group in system_manufacturer" v-bind:value="group.id" v-bind:key="group.id">
                                {{group.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control " v-model="type" required  >
                            <option disabled v-bind:value="null" selected>Choisissez un type de matériel</option>
                            <option v-for="group in system_type" v-bind:value="group.id" v-bind:key="group.id">
                                {{group.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>Sélectionnez le responsable pour cet outil</label>
                        <select id="responsableSelection" class="form-control" v-model="responsible" required>
                            <option disabled value="null">Choisissez un responsable</option>
                            <option v-for="adherent in adherents" v-bind:value="adherent.id" v-bind:key="adherent.id">
                                {{adherent.title}} {{adherent.firstname}} {{adherent.lastname}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="text-right mrg-top-5 d-flex justify-content-around">
                <!--<button class="btn btn-default" @click="$emit('update-system-done')">Annuler</button>-->
                <button class="btn btn-default"  @click="annuler()" formnovalidate>Annuler</button>  
                <b-button class="btn btn-default " variant="danger" @click="archiver()"> Archiver </b-button> 
                <button type="submit" class="btn btn-primary" @click="appliquer()">Modifier</button>
            </div>
            <div class="alert alert-danger" role="alert" v-if="error">
                Impossible d'éditer le sytème ! Veuillez contacter KEMTAG
                <i class="ti-close float-right mt-1" @click="error = false"></i>
            </div>
        </form>
    </div>                
        
</template>

<script>
    import api from "../../config/_api";
    import { mapGetters } from 'vuex';

    export default {
        name: "Edit",
        data () {
            return {
                system_selected: null,
                name: "",
                code: "",
                manufacturer: null,
                type: null,
                responsible: null,
                //stateForm: 0,
                error: false,
            }
        },
          props :{
            selected_system: {
                type: Object,
                required: false
            },
        },
        computed: {
            ...mapGetters({
                system_type: 'system_type/system_type',
                system_manufacturer: 'system_manufacturer/system_manufacturer',
                systems: 'systems/systems',
                adherents: 'adherents/adherents',
            }),
        },
        mounted() {
            if(this.selected_system){
                this.name = this.selected_system.name;
                this.code = this.selected_system.code;
                this.type = this.selected_system.type_id;
                this.manufacturer = this.selected_system.manufacturer_id;
                this.responsible =this.selected_system.responsible_id == 1 ? null :this.selected_system.responsible_id;
            }
            this.$store.dispatch('system_type/getTypes');
            this.$store.dispatch('system_manufacturer/getManufacturers');
            this.$store.dispatch('systems/getSystems');
            this.$store.dispatch('adherents/getUtilisateurs');
        },
        methods: {
            annuler(){
                if((this.name!=this.selected_system.name)||(this.manufacturer!=this.selected_system.manufacturer_id)||(this.code!=this.selected_system.code)||(this.type!=this.selected_system.type_id) ||(this.responsible!=this.selected_system.responsible.id)){
        
                    //console.log('La valeur du sélecteur  a changé !');
                    this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir annuler les modifications ?', {
                        title: 'Annuler les modifications',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Confirmer',
                        cancelTitle: 'Annuler',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                    }).then(value => {
                        if(value) {
                        this.$emit('update-system-done')
                        }
                    })
                }
                else{
                    this.$emit('update-system-done')
                }
                
            },
            archiver () {
                this.$bvModal.msgBoxConfirm('Êtes-vous certain de vouloir archiver le matériel ?', {
                    title: 'Archivage du matériel',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Confirmer',
                    cancelTitle: 'Annuler',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    
                }).then(value => {
                    if(value) {
                        this.selected_system.status = this.selected_system.status & ~1;
                        this.$store.dispatch('systems/archiver', {
                            id:  this._props.selected_system.id ,
                            status: this._props.selected_system.status,		
                        }).then((resp) => {
                            this.$emit('update-system-done',{'error' : false});	
                        }).catch((error) => {
                            this.error = true; 
                        })
                    }
                })
            },
            appliquer(){
                //empecher une requête si on un champ require vide
                if((this.code =="")|| (this.name=="")){
                    return;
                }
                this.$store.dispatch('systems/appliquer', {
                    id: this._props.selected_system.id ,
                    name: this.name,
                    type_id: this.type,
                    manufacturer_id: this.manufacturer,
                    status: this.selected_system.status,
                    empreinte_CO2 : this.selected_system.empreinte_CO2,
                    responsible_id: this.responsible,
                }).then(resp => {
                    this.$emit('update-system-done',{'error' : false, 'resp' : resp});
                }).catch((error) => {
                    this.error = true;
                })
            },
            check_input: function(event){
                if( event.keyCode < 8 ||  event.keyCode > 122 || event.keyCode==13 || event.keyCode==33 || event.keyCode==34 || event.keyCode==35 || event.keyCode==36 || event.keyCode==37 || event.keyCode==38 || event.keyCode==39 || event.keyCode==40 || event.keyCode==41 || event.keyCode==42 || event.keyCode==43 || event.keyCode==44 || event.keyCode==46 || event.keyCode==47 || event.keyCode==58 || event.keyCode==59 || event.keyCode==60 || event.keyCode==61 || event.keyCode==62 || event.keyCode==63 || event.keyCode==64 || event.keyCode==91 || event.keyCode==92 || event.keyCode==93 || event.keyCode==94 || event.keyCode==96) event.returnValue = false;
                if( event.which < 8 ||  event.which > 122  || event.which==13 || event.which==33 || event.which==34 || event.which==35 || event.which==36 || event.which==37 || event.which==38 || event.which==39 || event.which==40 || event.which==41 || event.which==42 || event.which==43 || event.which==44|| event.which==46 ||  event.which==47 ||  event.which==58 ||  event.which==59 ||  event.which==60 ||  event.which==61 ||  event.which==62 ||  event.which==63 ||  event.which==64 ||  event.which==91 ||  event.which==92 ||  event.which==93 ||  event.which==94 ||  event.which==96) return false;
            }
        }
    }
</script>

<style scoped>

</style>